import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  TableWrapper: {
    position: 'relative',
    '& #expandable-button': {
      transform: theme.direction === 'ltr' ? 'scaleX(1)' : 'scaleX(-1)',
      '&[class*="MUIDataTableSelectCell-expanded"]': {
        transform: theme.direction === 'ltr' ? 'scaleX(1) rotate(-90deg)' : 'scaleX(-1) rotate(-90deg)'
      }
    }
  },
  ApplyFilterWrapper: {
    marginTop: theme.spacing(4),
    textAlign: theme.direction === 'rtl' ? 'right' : 'left'
  },
  ActivateButton: {
    padding: theme.spacing(0)
  },
  dateChip: {
    display: 'flex',
    '& time': {
      marginLeft: theme.spacing(1)
    }
  },
  CustomExpandableRow: {
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  CustomExpandableColumn: {
    maxWidth: 'calc(100vw - 80px)',
    minWidth: '50%',
    width: 450,
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      width: 350
    }
  },
  codeComponent: {
    direction: theme.direction === 'rtl' ? 'rtl' : 'ltr',
    textAlign: theme.direction === 'rtl' ? 'right' : 'left'
  },
  CustomExpandableColumnFrom: {
    [theme.breakpoints.up('md')]: {
      paddingRight: 30
    }
  },
  arrowWrapper: {
    position: 'absolute',
    right: 2,
    top: '46%',
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  FilterChip: {
    display: 'flex',
    '& span': {
      marginLeft: theme.spacing(1)
    }
  },
  UserCustomMenu: {
    '& a, & button': {
      padding: theme.spacing(0.75, 1),
      width: '100%',
      textAlign: 'left',
      fontSize: theme.typography.pxToRem(16),
      justifyContent: 'flex-start'
    }
  },
  PermissionList: {
    paddingLeft: theme.spacing(3),
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0)
  },
  PermissionBtn: {
    padding: theme.spacing(0)
  }
}))
